import React, { useState } from "react";
import {
  ExtremelyDisappointedFace,
  DisappointedFace,
  NeutralFace,
  HappyFace,
  ExtremelyHappyFace,
} from "../../assets/svgcomponents";
import styles from "./smileyrating.module.css";

const SmmileyRating = ({ rating }: { rating: (rating: number) => void }) => {
  const [solid, setSolid] = useState(["", "", "", "", ""]);
  const handleFaceClick = (val: number) => {
    rating(val);
    const blank_arr = ["", "", "", "", ""];
    if (val > 3) {
      blank_arr[val - 1] = styles.green;
      if (solid[val - 1] === blank_arr[val - 1]) {
        setSolid(["", "", "", "", ""]);
      } else {
        setSolid(blank_arr);
      }
    } else if (val < 3) {
      blank_arr[val - 1] = styles.red;
      if (solid[val - 1] === blank_arr[val - 1]) {
        setSolid(["", "", "", "", ""]);
      } else {
        setSolid(blank_arr);
      }
    } else if (val === 3) {
      blank_arr[val - 1] = styles.gray;
      if (solid[val - 1] === blank_arr[val - 1]) {
        setSolid(["", "", "", "", ""]);
      } else {
        setSolid(blank_arr);
      }
    }
  };
  return (
    <div className={styles.smileyRating}>
      <span className={styles.ratingHeading}>Please rate this answer:</span>
      <div className={styles.ratingFacesParent}>
        <div
          className={`${styles.smileyFace} ${solid[0]} ${styles.sad}`}
          onClick={() => {
            handleFaceClick(1);
          }}
        >
          {ExtremelyDisappointedFace}
        </div>
        <div
          className={`${styles.smileyFace}  ${solid[1]} ${styles.sad}`}
          onClick={() => {
            handleFaceClick(2);
          }}
        >
          {DisappointedFace}
        </div>
        <div
          className={`${styles.smileyFace}  ${solid[2]} ${styles.neutral}`}
          onClick={() => {
            handleFaceClick(3);
          }}
        >
          {NeutralFace}
        </div>
        <div
          className={`${styles.smileyFace} ${solid[3]} ${styles.happy}`}
          onClick={() => {
            handleFaceClick(4);
          }}
        >
          {HappyFace}
        </div>
        <div
          className={`${styles.smileyFace}  ${solid[4]} ${styles.happy}`}
          onClick={() => {
            handleFaceClick(5);
          }}
        >
          {ExtremelyHappyFace}
        </div>
      </div>
    </div>
  );
};

export default SmmileyRating;
